/**
 * NumberUtils.js
 * Utility functions for number formatting and conversion
 */

const ARABIC_DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const THAI_DIGITS   = ['๐', '๑', '๒', '๓', '๔', '๕', '๖', '๗', '๘', '๙'];

/**
 * แปลงตัวเลขอารบิก (0-9) ในสตริงให้เป็นเลขไทย (๐-๙)
 * @param {string|number} value - ค่าที่ต้องการแปลง
 * @returns {string} - สตริงที่แปลงเลขเป็นเลขไทยแล้ว
 * @example
 *   toThaiDigits(2566)        // => '๒๕๖๖'
 *   toThaiDigits('100,000')   // => '๑๐๐,๐๐๐'
 *   toThaiDigits('ปี 2025')   // => 'ปี ๒๐๒๕'
 */
export const toThaiDigits = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[0-9]/g, (d) => THAI_DIGITS[parseInt(d, 10)]);
};

/**
 * แปลงเลขไทย (๐-๙) ในสตริงให้กลับเป็นเลขอารบิก (0-9)
 * @param {string} value - สตริงที่มีเลขไทย
 * @returns {string} - สตริงที่แปลงกลับเป็นเลขอารบิกแล้ว
 * @example
 *   toArabicDigits('๒๕๖๖')  // => '2566'
 */
export const toArabicDigits = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[๐-๙]/g, (d) => ARABIC_DIGITS[THAI_DIGITS.indexOf(d)]);
};

/**
 * แปลงตัวเลขให้มี comma (,) และแปลงเป็นเลขไทยด้วย (optional)
 * @param {string|number} value - ค่าตัวเลข
 * @param {boolean} [useThai=false] - ถ้า true จะแปลงเป็นเลขไทยด้วย
 * @returns {string}
 * @example
 *   formatNumber(1000000)            // => '1,000,000'
 *   formatNumber(1000000, true)      // => '๑,๐๐๐,๐๐๐'
 */
export const formatNumber = (value, useThai = false) => {
  if (value === null || value === undefined || value === '') return '';
  const formatted = Number(value).toLocaleString('en-US');
  return useThai ? toThaiDigits(formatted) : formatted;
};
